import type { CanonicalCase } from "./canonical-case";

function timestamp(value: string): number {
  const milliseconds = Date.parse(value);
  return Number.isNaN(milliseconds) ? Number.NEGATIVE_INFINITY : milliseconds;
}

/**
 * Reconciles a full remote snapshot with changes received while that snapshot
 * was loading. A concurrent new identifier is retained and a concurrent edit
 * wins only when its canonical revision is at least as new.
 */
export function mergeFreshestCaseSnapshots(
  remote: readonly CanonicalCase[],
  concurrent: readonly CanonicalCase[],
): CanonicalCase[] {
  const byId = new Map(remote.map((item) => [item.id, item]));
  concurrent.forEach((item) => {
    const current = byId.get(item.id);
    if (!current || timestamp(item.updatedAt) >= timestamp(current.updatedAt)) {
      byId.set(item.id, item);
    }
  });
  return [...byId.values()];
}
